





















import { Component, Vue, Watch } from 'vue-property-decorator';
import { SchoolUniformController } from '@/services/request.service';
import { ApplicationSchoolUniformResponse } from '@/services/__model';

@Component
export default class UniformList extends Vue {
  public list: Array<ApplicationSchoolUniformResponse> = [];

  public created(): void {
    // this.getList();
  }

  public getList(): void {
    SchoolUniformController.getApplicationSchoolUniformListByParent().then(res => {
      this.list = res.data;
    });
  }

  public jumpToDetail(item: any): void {
    if (item.studentId) {
      this.$store.commit('setUniformInfo', item);
      this.$router.push({ name: 'uniform', query: { studentId: item.studentId, name: item.name, enName: item.enName } });
    }
  }
}
